import { CopyButton } from "@arcadeai/design-system/components/ui/atoms/copy-button";
import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import { FormItem, FormLabel } from "@arcadeai/design-system/rhf";

type Props = {
  redirectUri: string | undefined;
  isLoading?: boolean;
};

export const ServerRedirectUriField = ({ redirectUri, isLoading }: Props) => (
  <FormItem>
    <FormLabel>Redirect URI</FormLabel>
    <div className="relative">
      <Input
        className="pr-10"
        disabled
        readOnly
        value={isLoading ? "Loading..." : redirectUri || ""}
      />
      <CopyButton
        className="absolute top-1/2 right-2 h-auto -translate-y-1/2 px-2 py-1"
        content={redirectUri || ""}
        disabled={!redirectUri || isLoading}
        variant="ghost"
      />
    </div>
    <p className="mt-1 text-muted-foreground text-xs">
      Use this redirect URI when configuring OAuth2 for this MCP server.
    </p>
  </FormItem>
);
